module.exports = __webpack_public_path__ + "img/pic_location_NewTaipeiCity.f3e9a5ea.png";